import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators} from '@angular/forms';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-committes-create',
  templateUrl: './committes-create.component.html',
  styleUrls: ['./committes-create.component.scss']
})
export class CommittesCreateComponent implements OnInit {

  constructor(private formBuilder: FormBuilder, private http: HttpClient, private ActivatedRoute: ActivatedRoute, private router: Router, @Inject('API_ENDPOINT') private api_endpoint: string) { }

  message = null;
  class = null;
  action = null;
  coursename = null;
  submitted = false;
  public committesForm: FormGroup;
  

  ngOnInit() {
    this.action = 'Submit';
    this.ActivatedRoute.params.subscribe(params => {
      let id = params['id'];
    
      // console.log(`${id}`);
      this.http.get<any>(this.api_endpoint+'/committesbyid/' + `${id}`).subscribe(
        data => {
          // console.log(data.data);
          if(data.data != null){
            this.action = 'Update';
            this.committesForm.patchValue({
              _id: data.data._id,
              name: data.data.course,
              members: data.data.coursename,
              functions: data.data.functions,
            });
          }
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
      });
    });
    

    this.committesForm = this.formBuilder.group({
      name: ['', Validators.required],
      members: ['', Validators.required],
      functions: ['', Validators.required],
      _id: ['']
    })
  }

  get f() { return this.committesForm.controls; }

  onFormSubmit() {
    
    this.submitted = true;

    if (this.committesForm.invalid) {
      return;
    }

    
      // console.log(this.coursename);
    if(this.action == 'Submit'){

      

    var data = {
      "name" : this.committesForm.value.name,
      "members" : this.committesForm.value.members,
      "functions" : this.committesForm.value.functions,
    };
    console.log(data);
    
    this.http.post<any>(this.api_endpoint+'/committes', data).subscribe(
      res => {
        console.log(res);
        if(res.Error){
          this.message = res.Error;
          this.class = 'btn btn-primary';
          return
        }else{
          this.message = 'Successfully Added';
          this.class = 'btn btn-success';
        } 
        this.router.navigateByUrl('/adminhkbkcms/eligibility/list-page');
    },
    (err: HttpErrorResponse) => {
      if (err.error instanceof Error) {
        console.log("Client-side error occured.");
      } else {
        console.log("Server-side error occured."+err);
      }
    });
    }else{
      var data1 = {
        "name" : this.committesForm.value.name,
      "members" : this.committesForm.value.members,
      "functions" : this.committesForm.value.functions,
        "_id" : this.committesForm.value._id,
      };
        // console.log(data1);     
        this.http.put<any>(this.api_endpoint+'/committes/', data1).subscribe(
        res => {
          console.log(res);
          if(res.Error){
            this.message = res.Error;
            this.class = 'btn btn-primary';
            return
          }else{
            this.message = 'Successfully Added';
            this.class = 'btn btn-success';
          } 
          this.router.navigateByUrl('/adminhkbkcms/eligibility/list-page');
        },
        (err: HttpErrorResponse) => {
          if (err.error instanceof Error) {
            console.log("Client-side error occured.");
          } else {
            console.log("Server-side error occured.");
          }
        });
    }
  }

}
